import { showToast } from "@certn/cascadia-react";
import { getRegionKey } from "@certn/utils";

import constants from "../../constants";

type RequestFn = (path: string, init?: RequestInit) => Promise<unknown>;

export type PurgeProtectedCacheFn = () => Promise<void>;

export type ExitProxySessionResult = { ok: true } | { ok: false };

export async function exitProxySession(request: RequestFn): Promise<void> {
  await request("/api/internal/case-management/customer-accounts/leave/", {
    method: "POST",
  });
}

export function redirectToCaseManagement(): void {
  window.open(
    `${constants.VITE_CASE_MANAGEMENT_URL}/${getRegionKey()}`,
    "_self"
  );
}

export async function exitProxySessionAndRedirect(
  request: RequestFn,
  purgeProtectedCache: PurgeProtectedCacheFn
): Promise<void> {
  await exitProxySession(request);
  await purgeProtectedCache();
  redirectToCaseManagement();
}

export async function exitProxySessionWithToast(
  request: RequestFn,
  t: (key: string) => string,
  purgeProtectedCache: PurgeProtectedCacheFn
): Promise<ExitProxySessionResult> {
  try {
    await exitProxySessionAndRedirect(request, purgeProtectedCache);
    return { ok: true };
  } catch (error) {
    console.error("Failed to stop proxy:", error);
    showToast(t("Something went wrong, try again"), { type: "error" });
    return { ok: false };
  }
}
